"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const RegistrationForm_class_1 = __importDefault(require("./RegistrationForm.class"));
exports.default = (0, vue_1.defineComponent)({
    setup: () => {
        const component = new RegistrationForm_class_1.default();
        (0, vue_1.onMounted)(component.mounted.bind(component));
        return {
            portalType: component.portalType
        };
    }
});
